<template>
  <div class="contents">
    <div class="headers">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>微信通知管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content_m">
      <div class="content_m_box">
        <h3>添加微信通知接收人员</h3>
        <span
          >*注意需要接收微信通知的人员，需要关注微信公众号，并在小程序注册会员信息</span
        >
      </div>
      <div class="content_m_input">
        <el-input
          placeholder="请输入要添加的用户姓名"
          v-model="input"
          clearable
          class="inputs"
        >
        </el-input>
        <el-button type="primary" class="btns" @click="queryData">搜索|添加</el-button>
      </div>
    </div>

    <div class="footer">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
        <el-table-column prop="_openid" label="OPENID(小程序)" width="280">
        </el-table-column>
        <!-- <el-table-column prop="name" label="OPENID(公众号)" width="180">
        </el-table-column> -->
        <el-table-column prop="unionid" label="UNIONID"> </el-table-column>
        <el-table-column prop="isStatus" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isStatus"
              ><i class="el-icon-success" style="color: #67c23a; font-size: 20px"></i>
            </span>
            <span v-else
              ><i class="el-icon-error" style="color: #f56c6c; font-size: 20px"></i
            ></span>
            {{ scope.row.isStatus == undefined ? "未开通" : "已开通" }}

            <el-tooltip
              v-if="!scope.row.isStatus"
              class="item"
              effect="dark"
              content="开通方式：关注微信公众号，注册会员。以前已经注册过会员的，在公众号回复任意消息，自动更新所需的unionId"
              placement="top"
            >
              <i class="el-icon-info" style="font-size: 20px"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="DeleteClick(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "WechatMsg",
  data() {
    return {
      input: "", //输入框的值
      tableData: [],
      loading: true,
    };
  },
  methods: {
    //查找用户
    queryData() {
      if (this.input == "") {
        this.$message({
          message: "请填写要添加的用户姓名",
          type: "warning",
        });
        return;
      }
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({name:"${this.input}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (res.data.data.length == 0) {
            //没有查询到用户信息
            this.$alert("未查询到客户信息，请先在小程序注册会员", "查询结果", {
              confirmButtonText: "关闭",
            });
            return;
          }
          //已查询到用户信息，查询客户是否有微信公众号openid
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("openids").where({unionid:"${res.data.data[0].unionid}"}).limit(1000).get()`,
            })
            .then((r) => {
              r.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              if (r.data.data.length > 0) {
                //有公众号openid
                this.addWechatMsg(r.data.data[0]);
              } else {
                //没有公众号openid
                this.$alert(
                  "未查询到该用户的公众号openid，请用户关注微信公众号",
                  "温馨提示",
                  {
                    confirmButtonText: "关闭",
                  }
                );
              }
            });
        });
    },
    //添加模板消息接收
    addWechatMsg(event) {
      this.$confirm(`是否将用户${this.input}接收微信模板消息?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //将用户添加到模板消息接收
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("weReviewTemplate").where({}).limit(1000).get()`,
            })
            .then((res) => {
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });
              if (res.data.data.length > 0) {
                //有模板
                this.axios
                  .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("weReviewTemplate").add({data:{fhTemplate:"${res.data.data[0].fhTemplate}",hsTemplate:"${res.data.data[0].hsTemplate}",mpappId:"${res.data.data[0].mpappId}",templateId:"${res.data.data[0].templateId}",touser:"${event.openid}",unionid:"${event.unionid}",xcxappId:"${res.data.data[0].xcxappId}",xgdTemplate:"${res.data.data[0].xgdTemplate}"}})`,
                  })
                  .then((ra) => {
                    if (ra.data.errmsg == "ok") {
                      this.$message({
                        type: "success",
                        message: "添加成功!",
                      });
                      this.getData();
                      this.input = "";
                    }
                  });
              } else {
                //没有模板消息，需要手动添加
                this.$alert("该店铺未添加过微信通知模板，请联系管理员添加", "温馨提示", {
                  confirmButtonText: "关闭",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消添加",
          });
          this.input = "";
        });
    },
    //删除用户
    DeleteClick(event) {
      this.$confirm(`是否删除用户${event.name}的微信通知功能?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("weReviewTemplate").where({unionid:"${event.unionid}"}).remove()`,
            })
            .then((res) => {
              if (res.data.errmsg == "ok") {
                this.$notify({
                  title: "删除成功",
                  message: `用户${event.name}的微信通知，已成功删除`,
                  type: "success",
                });
                this.getData();
                this.input = "";
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.input = "";
        });
    },
    //查找touser所有数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weReviewTemplate").where({}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.getUserData(res.data.data);
        });
    },

    //查找对应的的名字信息
    getUserData(event) {
      let newarr = [];
      for (let i = 0; i < event.length; i++) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("user2020zl").where({unionid:"${event[i].unionid}"}).limit(1000).get()`,
          })
          .then((r) => {
            r.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });

            let obj = r.data.data[0];
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("openids").where({unionid:"${event[i].unionid}"}).limit(1000).get()`,
              })
              .then((re) => {
                re.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                if (re.data.data[0] !== undefined) {
                  if (event[i].unionid == re.data.data[0].unionid) {
                    obj["isStatus"] = "true";
                  }
                }

                newarr.push(obj);
              });
          });

        this.tableData = newarr;
        this.loading = false;
      }
    },
  },
  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.getData();
    }, 800);
  },
};
</script>
<style scoped>
.headers {
  height: 30px;
  width: 100%;
  background-color: #ffffff;
  /* margin: 5px 10px; */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content_m {
  margin: 15px 0;
  width: 100%;
  height: 200px;
  background-color: #ffffff;
  position: relative;
}
.content_m_box {
  position: absolute;
  width: 95%;
  height: 80%;
  top: 10%;
  left: 2.5%;

  /* margin: 20px auto; */
  /* display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center; */
}
.content_m_box h3 {
  margin: 0 0;
  padding: 0 0;
}
.inputs {
  width: 20%;
}
.content_m_input {
  display: flex;
  flex-direction: row;
  position: absolute;
  width: 100%;
  height: 80%;
  top: 50%;
  left: 2.5%;
}
.btns {
  height: 40px;
}
.footer {
  width: 100%;
  /* height: 200px; */
  background-color: #ffffff;
}
</style>
